import React, { useState, useEffect } from 'react';
import { Row, Table, Select, Input, Button, Space, DatePicker, message,Form,Typography } from 'antd';
import { MinusCircleOutlined, PlusOutlined, SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import axios from "axios";
import {useNavigate} from 'react-router-dom'
import { viewSurveySearch,viewLeadSearchQuery,masterSource,checkMPR ,checkSupplyNumber} from '../service/UserDetails';

const { Option } = Select;
const { RangePicker } = DatePicker;

const fieldOptions = [
    { label: 'Lead Id', value: 'id', dataType: 'text' },
    { label: 'Lead Date', value: 'created_at', dataType: 'date' },
    { label: 'Distribution Date', value: 'distributed_on', dataType: 'date' },
    { label: 'Business Name', value: 'business_name', dataType: 'text' },
    { label: 'Customer Name', value: 'customer_name', dataType: 'text' },
    { label: 'Billing Address', value: 'billing_address', dataType: 'text' },
    { label: 'Billing Postcode', value: 'billing_postcode', dataType: 'text' },
    { label: 'Contact Number', value: 'contact_number', dataType: 'text' },
    { label: 'Email Address', value: 'email_address', dataType: 'text' },
    { label: 'Product', value: 'product_id', dataType: 'text' },
    { label: 'Electricity Current Supplier', value: 'elec_current_supplier', dataType: 'dropdown' },
    { label: 'Gas Current Supplier', value: 'gas_current_supplier', dataType: 'text' },
    { label: 'Gas Account Number', value: 'gas_account_number', dataType: 'text' },
    { label: 'Electric Account Number', value: 'elec_account_number', dataType: 'text' },
    { label: 'Supply Number', value: 'supply_number', dataType: 'text' },
    { label: 'MPR Number', value: 'gas_mpr', dataType: 'text' },
    { label: 'Electric MSN', value: 'elec_msn', dataType: 'text' },
    { label: 'Gas MSN', value: 'gas_msn', dataType: 'text' },
    { label: 'Electric Contract End Date', value: 'elec_contract_end_date', dataType: 'date' },
    { label: 'Gas Contract End Date', value: 'gas_contract_end_date', dataType: 'date' },
    { label: 'Electric EAC', value: 'elec_eac', dataType: 'number' },
    { label: 'Gas EAC', value: 'gas_eac', dataType: 'number' },
    { label: 'Gas Billing Amount', value: 'gas_billing_amount', dataType: 'number' },
    { label: 'Electric Billing Amount', value: 'elec_billing_amount', dataType: 'number' },
    { label: 'Gas Meter Type', value: 'gas_metertype', dataType: 'text' },
    { label: 'Electricity Meter Type', value: 'elec_metertype', dataType: 'text' },
    { label: 'Gas Standing Charge', value: 'gas_standing_charge', dataType: 'text' },
    { label: 'Electric Standing Charge', value: 'elec_standing_charge', dataType: 'text' },
    { label: 'Gas Unit Rate', value: 'gas_unit_rate', dataType: 'text' },
    { label: 'Electric Unit Rate', value: 'elec_unit_rate', dataType: 'text' },
    { label: 'Night Rate', value: 'night_rate', dataType: 'text' },
    { label: 'Eve Weekend', value: 'eve_weekend', dataType: 'text' },
    { label: 'Capacity Charge', value: 'capacity_charge', dataType: 'text' },
    { label: 'FIT Charge', value: 'elec_fit_charge', dataType: 'text' },
    { label: 'Lead Status', value: 'lead_status_list_id', dataType: 'text' },
    { label: 'Sales Lead Status', value: 'sales_status_list_id', dataType: 'text' },
    { label: 'Call Back Date', value: 'callback_date', dataType: 'date' },
    { label: 'Sales Feedback', value: 'sales_feedback', dataType: 'text' }
  ];
  

const LeadSearchSales = () => {
  const [dataSource, setDataSource] = useState([]);
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedField, setSelectedField] = useState('');
  const [productSupplierOptions, setProductSupplierOptions] = useState([]);
  const [showElecCurrentSupplierDropdown, setShowElecCurrentSupplierDropdown] = useState(false);
  const [showGasCurrentSupplierDropdown, setShowGasCurrentSupplierDropdown] = useState(false);
  const [showGasMeterTypeDropdown, setShowGasMeterTypeDropdown] = useState(false);
  const [showElecMeterTypeDropdown, setShowElecMeterTypeDropdown] = useState(false);
  const [showLeadStatusDropdown, setShowLeadStatusDropdown] = useState(false);

  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [gasCurrentSupplierOptions , setCurrentSupplierGas] = useState([]);
  const [elecCurrentSupplierOptions , setCurrentSupplierElectricity] = useState([]);
  const [leadStatusTypes, setLeadStatusTypes] = useState(new Set());
  const [leadStatusArray, setLeadStatusArray] = useState([]);
  const [elecMeterTypeOptions , setMeterTypeOptionElect] = useState([]);
  const [gasMeterTypeOptions , setMeterTypeOptionGas] = useState([]);
  const [leadStatusOptions , setLeadStatusOptions] = useState([]);
  const [salesStatusOptions , setSalesStatusOptions] = useState([]);

  const [showSalesStatusDropdown, setShowSalesStatusDropdown] = useState(false);
  const [mpr, setMpr] = useState('');
  const [supplyNumber, setSupplyNumber] = useState('');
  const [totalNoOfRecords , setTotalNoOfRecords] = useState('');
  const [selectedValue, setSelectedValue] = useState(undefined);
  
  const [mprData, setMprData] = useState(null); // State to store the response data
  const [supplyNumberData, setSupplyNumberData] = useState(null); // State to store the response data

  
  const { Text } = Typography;
  const navigator = useNavigate();
    const [user, setUser] = useState({ role: 'sales',});

    const handleClick = (record) => {
      // Check if lead_status is 5 or 6
      if (record?.relations?.sales_status?.id === 9 || record?.relations?.sales_status?.id === 11) {
        alert("Not allowed to open lead with Status Sold or Sold Renewal");
        return;
      }

      const url = `/sales-lead/${record.id}?isEdit=true`;
      localStorage.setItem('isEdit', true);
      window.open(url, '_blank');
    };

  useEffect(() => {
    const callBackResponse = async () => {
      try {
  //       const res = await viewSurveySearch();
  //       console.log(res.data.data[0].attributes);
  //       const mappedData = res.data.data;
  //       console.log('mappedData', mappedData);
   
  // const leadStatuses = new Set(mappedData.map(record => record.relations.lead_status.name));
  // console.log('Lead Status Types:', Array.from(leadStatusTypes));

  // const statuses = mappedData
  // .map(record => record.relations?.lead_status?.name)
  // .filter(status => status) // Remove undefined/null values
  // .filter((status, index, self) => self.indexOf(status) === index); // Remove duplicates
  // console.log('Lead Status Array:', statuses);
  // setLeadStatusArray(statuses);
  // const hasQualityStatus = leadStatusArray.includes('Quality');


   //const hasQualityStatus = leadStatuses.has('Quality');
  //  console.log('hasQualityStatus'+hasQualityStatus);
  //  const hasQualityLowStatus = leadStatuses.has('Quality Low');
  //  setLeadStatusTypes(leadStatuses);
  //       setDataSource(mappedData);
  //       setFilteredDataSource(mappedData); // Initialize filteredDataSource

        // Fetch product supplier options
        const response = await masterSource();
        const meterOptGas = [];
        const meterOptElec = [];
        const productsSupplier = [];
        const currentSupplierGas = [];
        const currentSupplierElectricity = [];
        const leadStatus = [];
        const salesStatus = [];
        //response.data.suppliers.map(item=> currentSupplier.push({label: item.supplier_name,value: item.id}))
        response.data.products.map(item=> productsSupplier.push({label: item.product_name,value: item.id}))
        response.data.meter_types.map(item=> {
         if(item.product_id === 1){
         meterOptElec.push({label: item.meter_type,value: item.id})
        }else if(item.product_id === 2){
         meterOptGas.push({label: item.meter_type,value: item.id})
        } })
        response.data.lead_statuses.map(item=> leadStatus.push({label:item.status,value: item.id}))
        response.data.sales_statuses.map(item=> salesStatus.push({label:item.status,value: item.id}))

   
        response.data.suppliers.map(item=> {
         if(item.product_id === 1){
           currentSupplierElectricity.push({label: item.supplier_name,value: item.id})
           
        }else if(item.product_id === 2){
         currentSupplierGas.push({label: item.supplier_name,value: item.id})
        } 
        }
        )
        setMeterTypeOptionElect(meterOptElec);
        setMeterTypeOptionGas(meterOptGas);
        setProductSupplierOptions(productsSupplier);
        setCurrentSupplierGas(currentSupplierGas);
        setCurrentSupplierElectricity(currentSupplierElectricity);
        setLeadStatusOptions(leadStatus)
        setSalesStatusOptions(salesStatus)
        
      } catch (err) {
        console.log(err.response.data.error);
        if (err.response.data.error === "No leads found with the provided filters") {
          console.log("No leads are added");
        }
      }
    };
    callBackResponse();
  }, []);

  const columns = [
    {
      title: 'Lead ID',
      dataIndex: 'id',
      width: 100,
      render: (id, record) => (
        <span
          style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} // Optional styling
          onClick={() => handleClick(record)} // Call handleClick directly
        >
          {id}
        </span>
      )
    },
  {
     // key:'lead_date',
      title : 'Lead Date',
     // dataIndex : 'lead_date',
     render: (record) => { return (<p>{moment.utc(record.attributes.created_at).format("DD-MM-YYYY")}</p>)},
    // render: (record) => record.attributes.created_at,
      width: 150
  },
  {
    title : 'Distribution Date',
    width: 150,
    render: (record) => { return (<p>{record.attributes.distributed_on ? moment(record.attributes.distributed_on).format("DD-MM-YYYY"): ""}</p>)},
    
  },
  {
    key: 'business_name',
    title: 'Business Name',
    render: (record) => {
      const soldStatus = record.relations?.sales_status?.name;
      const isSoldStatus = soldStatus === 'Sold';
      const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
      return isSoldStatus || isSoldLowEACStatus
        ? 'XXXXX'
        : <p>{record.attributes?.business_name}</p>;
    },
    width: 150,
  },
    {
      key: 'customer_name',
      title: 'Customer Name',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.customer_name}</p>;
      },
      width: 150,
    },
    {
      key: 'billing_address',
      title: 'Billing Address',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.billing_address}</p>;
      },
      width: 150,
    },
    {
      key: 'billing_postcode',
      title: 'Billing Postcode',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.billing_postcode}</p>;
      },
      width: 150,
    },
    {
      key: 'contact_number',
      title: 'Contact Number',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.contact_number}</p>;
      },
      width: 150,
    },
    {
      key: 'email_address',
      title: 'Email Address',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.email_address}</p>;
      },
      width: 150,
    },
    {
      key: 'product_id',
      title: 'Product',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.product_id === 1 ? "Electricity" : "Gas"}</p>;
      },
      width: 150,
    },
    {
      key: 'elec_current_supplier',
      title: 'Electricity Current Supplier',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.relations?.supplier?.electricity?.name}</p>;
      },
      width: 150,
    },
    {
      key: 'gas_current_supplier',
      title: 'Gas Current Supplier',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.relations?.supplier?.gas?.name}</p>;
      },
      width: 150,
    },
    {
      key: 'gas_account_number',
      title: 'Gas Account Number',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.gas?.account_number}</p>;
      },
      width: 150,
    },
    {
      key: 'electric_account_number',
      title: 'Electric Account Number',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.account_number}</p>;
      },
      width: 150,
    },
    {
      key: 'supply_number',
      title: 'Supply Number',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        if (isSoldStatus || isSoldLowEACStatus) {
          return 'XXXXX';
        }
        const supplyNumber = record.attributes?.electricity?.supply_number;
        return supplyNumber ? <p>{`${supplyNumber.slice(0, 8)} ${supplyNumber.slice(8)}`}</p> : <p></p>;
      },
      width: 170,
    },
    {
      key: 'mpr_number',
      title: 'MPR Number',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.gas?.mpr}</p>;
      },
      width: 150,
    },
    {
      key: 'electric_msn',
      title: 'Electric MSN',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.msn}</p>;
      },
      width: 150,
    },
    {
      key: 'gas_msn',
      title: 'Gas MSN',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.gas?.msn}</p>;
      },
      width: 150,
    },
    {
      key: 'electric_contract_end_date',
      title: 'Electric Contract End Date',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.contract_end_date}</p>;
      },
      width: 150,
    },
    {
      key: 'gas_contract_end_date',
      title: 'Gas Contract End Date',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.gas?.contract_end_date}</p>;
      },
      width: 150,
    },
    {
      key: 'electric_eac',
      title: 'Electric EAC',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.eac}</p>;
      },
      width: 150,
    },
    {
      key: 'gas_eac',
      title: 'Gas EAC',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.gas?.eac}</p>;
      },
      width: 150,
    },
    {
      key: 'gas_billing_amount',
      title: 'Gas Billing Amount',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.gas?.billing_amount}</p>;
      },
      width: 150,
    },
    {
      key: 'electric_billing_amount',
      title: 'Electric Billing Amount',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.billing_amount}</p>;
      },
      width: 150,
    },
    {
      key: 'gas_metertype',
      title: 'Gas Meter Type',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.relations?.gas?.name}</p>;
      },
      width: 150,
    },
    {
      key: 'elec_metertype',
      title: 'Electricity Meter Type',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.relations?.electricity?.name}</p>;
      },
      width: 150,
    },
    {
      key: 'gas_standing_charge',
      title: 'Gas Standing Charge',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.gas?.standing_charge}</p>;
      },
      width: 150,
    },
    {
      key: 'electric_standing_charge',
      title: 'Electric Standing Charge',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.standing_charge}</p>;
      },
      width: 150,
    },
    {
      key: 'gas_unit_rate',
      title: 'Gas Unit Rate',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.gas?.unit_rate}</p>;
      },
      width: 150,
    },
    {
      key: 'electric_unit_rate',
      title: 'Electric Unit Rate',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.unit_rate}</p>;
      },
      width: 150,
    },
    {
      key: 'night_rate',
      title: 'Night Rate',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.night_rate}</p>;
      },
      width: 150,
    },
    {
      key: 'eve_weekend',
      title: 'Eve Weekend',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.eve_weekend}</p>;
      },
      width: 150,
    },
    {
      key: 'capacity_charge',
      title: 'Capacity Charge',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.capacity_charge}</p>;
      },
      width: 150,
    },
    {
      key: 'fit_charge',
      title: 'FIT Charge',
      render: (record) => {
        const soldStatus = record.relations?.sales_status?.name;
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.electricity?.fit_charge}</p>;
      },
      width: 150,
    },
    {
      key: 'lead_status_list_id',
      title: 'Lead Status',
      // render: (record) => leadStatusTypes.has('Sold') || leadStatusTypes.has('Sold Low')
      //   ? 'XXXXX'
      //   : <p>{record.relations.lead_status.name}</p>,
      render: (record) => <p>{record.relations.lead_status.name}</p>,

      width: 150,
    },
    {
      //  key:'lead_status_list_id',
        title : 'Sales Lead Status',
        render: (record) => record.relations.sales_status.name,
     //   dataIndex : 'lead_status_list_id',
        width: 150
    },
    {
      key: 'callback_date',
      title: 'Call Back Date',
      render: (record) => {
        // Extract lead status from the record
        const soldStatus = record.relations?.sales_status?.name;
    
        // Check if lead status is 'Sold' or 'Sold Renewal'
        const isSoldStatus = soldStatus === 'Sold';
        const isSoldLowEACStatus = soldStatus === 'Sold Renewal';
    
        return isSoldStatus || isSoldLowEACStatus
          ? 'XXXXX'
          : <p>{record.attributes?.callback_date ? moment(record.attributes.callback_date).format("DD-MM-YYYY") : ""}</p>;
      },
      width: 150,
    }
  ];

  const handleAddField = (value) => {
    if (value) {
      const selectedOption = fieldOptions.find(option => option.value === value);
      // const newField = {
      //   name: selectedOption.value,
      //   operator: selectedOption.dataType === 'date' ? 'from to' : 'exact',
      //   value: selectedOption.dataType === 'date' ? [null, null] : '',
      //   dataType: selectedOption.dataType,
      // };
       // Create a new field object based on the selected option
    const newField = {
      name: selectedOption.value,
      operator: selectedOption.dataType === 'date' || selectedOption.dataType === 'number' ? 'range' : 'exact', // Default to 'range' for date and number
      value: selectedOption.dataType === 'date' ? [null, null] : (selectedOption.dataType === 'number' ? [null, null] : ''), // Default range to [null, null] for date and number
      dataType: selectedOption.dataType,
    };
      setFields([...fields, newField]);
      setSelectedField('');
    //  handleSearch([...fields, newField]); // Update filtered data when a new field is added

    if (value === 'product_id') {
      setShowProductDropdown(true);
      newField.dataType = 'select';
    } else if (value === 'elec_current_supplier') {
      setShowElecCurrentSupplierDropdown(true);
      newField.dataType = 'select';
    } else if (value === 'gas_current_supplier') {
      setShowGasCurrentSupplierDropdown(true);
      newField.dataType = 'select';
    } else if (value === 'gas_metertype') {
      setShowGasMeterTypeDropdown(true);
      newField.dataType = 'select';
    } else if (value === 'elec_metertype') {
      setShowElecMeterTypeDropdown(true);
      newField.dataType = 'select';
    }else if (value === 'lead_status_list_id') {
      setShowLeadStatusDropdown(true);
      newField.dataType = 'select';
    }else if (value === 'sales_status_list_id') {
      setShowSalesStatusDropdown(true);
      newField.dataType = 'select';
    }

    
    }
    setSelectedValue('Select a field');
  };

  const handleRemoveField = (index) => {
    const newFields = fields.filter((_, i) => i !== index);
    setFields(newFields);
  //  handleSearch(newFields); // Update filtered data when a field is removed
  // Hide product dropdown if there are no more product fields
  if (newFields.every(field => field.name !== 'product_id')) {
    setShowProductDropdown(false);
  }

  if (newFields.every(field => field.name !== 'elec_current_supplier')) {
    setShowElecCurrentSupplierDropdown(false);
  }

  if (newFields.every(field => field.name !== 'gas_current_supplier')) {
    setShowGasCurrentSupplierDropdown(false);
  }

  if (newFields.every(field => field.name !== 'gas_metertype')) {
    setShowGasMeterTypeDropdown(false);
  }

  if (newFields.every(field => field.name !== 'elec_metertype')) {
    setShowElecMeterTypeDropdown(false);
  }

  if (newFields.every(field => field.name !== 'lead_status_list_id')) {
    setShowLeadStatusDropdown(false);
  }

  if (newFields.every(field => field.name !== 'sales_status_list_id')) {
    setShowSalesStatusDropdown(false);
  }

  
  };

  const handleFieldChange = (index, key, value) => {
    const newFields = [...fields];
    newFields[index][key] = value;
    setFields(newFields);
    //handleSearch(newFields); // Update filtered data when a field is changed
  };
   
  const handleSearch = async () => {
    try {
    //  const sqlQuery = buildSQLQuery(fields);
   //   const sqlQuery = buildJSONFilters(fields);
      const jsonFilters = buildJSONFilters(fields);
    console.log('JSON Filters:', JSON.stringify(jsonFilters, null, 2));

      
    //  console.log("Generated SQL Query for SQL Developer:", sqlQuery);
     // const encodedQuery = encodeURIComponent(JSON.stringify(jsonFilters));
      const encodedQuery = JSON.stringify(jsonFilters.filters);
      console.log("Encoded SQL Query:", encodedQuery);
      try {
        const res = await viewLeadSearchQuery(encodedQuery);
        console.log(res.data.data[0].attributes);
        const mappedData = res.data.data;
        console.log('viewSearchQuery', mappedData);
        setTotalNoOfRecords(mappedData.length);
       // setDataSource(mappedData);
        setFilteredDataSource(mappedData); // Initialize filteredDataSource
        
      } catch (err) {
        console.log(err.response.data.error);
        if (err.response.data.error === "No leads found with the provided filters") {
          message.error("No leads found with the provided filters");
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  console.log("check date",fields)
  const buildJSONFilters = (fields) => {
    return {
      filters: fields.map(field => {
        const { name, operator, value, dataType } = field;
        
        if (dataType === 'date' && operator === 'range') {
          return {
            column: name,
            operator: 'BETWEEN',
            values: value
          };
        } else if (dataType === 'number' && operator === 'range') {
          return {
            column: name,
            operator: 'BETWEEN',
            values: value
          };
        } else if (dataType === 'text') {
          let formattedValue = value;
          if (operator === 'like') {
            return {
              column: name,
              operator: 'LIKE',
              value: formattedValue
            };
          } else if (operator === 'unlike') {
            return {
              column: name,
              operator: 'NOT LIKE',
              value: formattedValue
            };
          } else {
            return {
              column: name,
              operator: '=',
              value: formattedValue
            };
          }
        } else if (dataType === 'select') {
          return {
            column: name,
            operator: '=',
            value: value
          };
        } else if (dataType === 'number') {
          return {
            column: name,
            operator: operator,
            value: value
          };
        }
        return null;
      }).filter(filter => filter !== null)
    };
  };
  

  // const buildSQLQuery = (fields) => {
  //   const sqlConditions = fields.map(field => {
  //     const { name, operator, value, dataType } = field;
      
  //     if (dataType === 'date' && operator === 'from to') {
  //       return `${name} BETWEEN '${value[0]}' AND '${value[1]}'`;
  //     }  else if (dataType === 'number' && operator === 'range') {
  //       return `${name} BETWEEN ${value[0]} AND ${value[1]}`;
  //     } else if (dataType === 'text') {
  //       let formattedValue = value;
  //       if (operator === 'like') {
  //         formattedValue = `%${value}%`;
  //         return `${name} LIKE '${formattedValue}'`;
  //       } else if (operator === 'unlike') {
  //         formattedValue = `%${value}%`;
  //         return `${name} NOT LIKE '${formattedValue}'`;
  //       } else {
  //         return `${name} = '${formattedValue}'`;
  //       }
  //     } else if (dataType === 'number') {
  //       return `${name} ${operator} ${value}`;
  //     }else if (dataType === 'select') {
  //       // Dropdown selection query
  //       // Assuming value is a single value for select type fields
  //       return `${name} = '${value}'`;
  //     }
  //     return '';
  //   }).filter(condition => condition).join(' AND ');
  
  //   return `${sqlConditions}`;
  // };

  

  const handleSupplyNumberCheck = async () => {
    try {
      const response = await checkSupplyNumber(supplyNumber);
      const { data } = response;
      // Update the state with the response data
      setSupplyNumberData(data);
      // Construct a message string from the response data
      const messageContent = `
        Lead ID: ${data.leadID}\n
        Created On: ${data.created_on}\n
        Supply Number: ${data.supply_number}\n
        Lead Status: ${data.lead_status_name}\n
        Sales Status: ${data.sales_status_name}
      `;
      // Display the message in a success message box
      message.success(messageContent);
    } catch (error) {
      console.error('Error checking MPR:', error);
      message.error('Error checking MPR');
    }
  };

  const handleMPRCheck = async () => {
    try {
      const response = await checkMPR(mpr);
      const { data } = response;
      // Update the state with the response data
      setMprData(data);
      // Construct a message string from the response data
      const messageContent = `
        Lead ID: ${data.leadID}\n
        Created On: ${data.created_on}\n
        MPR Number: ${data.mpr_number}\n
        Lead Status: ${data.lead_status_name}\n
        Sales Status: ${data.sales_status_name}
      `;
      // Display the message in a success message box
      message.success(messageContent);
    } catch (error) {
      console.error('Error checking MPR:', error);
      message.error('Error checking MPR');
    }
  };


  const fieldLabels = {
    'id': 'Lead Id',
    'created_at': 'Lead Date',
    'business_name': 'Business Name',
    'customer_name': 'Customer Name',
    'billing_address': 'Billing Address',
    'billing_postcode': 'Billing Postcode',
    'contact_number': 'Contact Number',
    'email_address': 'Email Address',
    'product_id': 'Product',
    'elec_current_supplier': 'Electricity Current Supplier',
    'gas_current_supplier': 'Gas Current Supplier',
    'gas_account_number': 'Gas Account Number',
    'elec_account_number': 'Electric Account Number',
    'supply_number': 'Supply Number',
    'mpr': 'MPR Number',
    'elec_msn': 'Electric MSN',
    'gas_msn': 'Gas MSN',
    'elec_contract_end_date': 'Electric Contract End Date',
    'gas_contract_end_date': 'Gas Contract End Date',
    'elec_eac': 'Electric EAC',
    'gas_eac': 'Gas EAC',
    'gas_billing_amount': 'Gas Billing Amount',
    'elec_billing_amount': 'Electric Billing Amount',
    'gas_metertype': 'Gas Meter Type',
    'elec_metertype': 'Electricity Meter Type',
    'gas_standing_charge': 'Gas Standing Charge',
    'elec_standing_charge': 'Electric Standing Charge',
    'gas_unit_rate': 'Gas Unit Rate',
    'elec_unit_rate': 'Electric Unit Rate',
    'night_rate': 'Night Rate',
    'eve_weekend': 'Eve Weekend',
    'capacity_charge': 'Capacity Charge',
    'elec_fit_charge': 'FIT Charge',
    'lead_status_list_id': 'Lead Status',
    'callback_date': 'Call Back Date'
  };
  const addedFieldNames = fields.map(field => field.name);
  

  return (

    <div className="main">
      <div style={{ padding: "10px" }}>
        
        <Space>
          <Select
            value={selectedValue}
            onChange={handleAddField}
            style={{ width: 200 }}
            placeholder="Select a field"
          >
            {fieldOptions.map(option => (
              <Option key={option.value} value={option.value} 
         //     disabled={addedFieldNames.includes(option.value)}
              >
                {option.label}
              </Option>
            ))}
          </Select>
        </Space>
        <fieldset> 
          <legend>Search Filters</legend>
        {fields.map((field, index) => (
          
          <Space key={index} style={{ display: 'flex', marginTop: 8 }} align="baseline">
            
            <span>{field.name}</span>
            {field.dataType === 'date' ? (
              <RangePicker
              //  value={field.value[0] && field.value[1] ? [moment(field.value[0]), moment(field.value[1])] : []}
                onChange={(dates, dateStrings) => handleFieldChange(index, 'value', dateStrings)}
              />
            ) : field.dataType === 'number' ? (
              <>
                <Input
                  type="number"
                  value={field.value[0]}
                  onChange={(e) => handleFieldChange(index, 'value', [e.target.value, field.value[1]])}
                  placeholder="Min"
                  style={{ width: '80px', marginRight: '8px' }}
                />
                <Input
                  type="number"
                  value={field.value[1]}
                  onChange={(e) => handleFieldChange(index, 'value', [field.value[0], e.target.value])}
                  placeholder="Max"
                  style={{ width: '80px' }}
                />
              </>
            ) : (
              <> 
                {field.name === 'product_id' && showProductDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {productSupplierOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : field.name === 'elec_current_supplier' && showElecCurrentSupplierDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {elecCurrentSupplierOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : field.name === 'gas_current_supplier' && showGasCurrentSupplierDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {gasCurrentSupplierOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : field.name === 'lead_status_list_id' && showLeadStatusDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {leadStatusOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                 ): field.name === 'sales_status_list_id' && showSalesStatusDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {salesStatusOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                
                ):field.name === 'gas_metertype' && showGasMeterTypeDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {gasMeterTypeOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : field.name === 'elec_metertype' && showElecMeterTypeDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {elecMeterTypeOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <>
                    <Select
                      value={field.operator}
                      onChange={(value) => handleFieldChange(index, 'operator', value)}
                      style={{ width: 120 }}
                    >
                      <Option value="exact">exact</Option>
                      <Option value="like">like</Option>
                      <Option value="unlike">unlike</Option>
                    </Select>
                    <Input
                      value={field.value}
                      onChange={(e) => handleFieldChange(index, 'value', e.target.value)}
                      placeholder="Enter value"
                    />
                  </>
                )}
              </>
            )}
            <DeleteOutlined onClick={() => handleRemoveField(index)} />
          </Space>
        ))}
        </fieldset>
        <Button icon={<SearchOutlined />} type="primary" onClick={() => handleSearch(fields)} style={{ marginTop: 4 }}>
          Search
        </Button>
      </div>
      <div style={{ padding: '5px' }}>
      {/* Form with label and input for MPR field */}
      <Form layout="inline">
        <Form.Item label="MPR" style={{marginLeft:'90px',marginTop:'8px'}}>
          <Input
          style={{fontSize:'13px'}}
            value={mpr}
            onChange={(e) => setMpr(e.target.value)}
            placeholder="Enter MPR"
          />
        </Form.Item>
        <Button type="primary" onClick={handleMPRCheck} style={{marginRight:'15px',marginTop:'8px'}}>
        Check
      </Button>
      {/* Display the response data */}
      {mprData && (
        <Form.Item className="supply-details-form-item">
        <Text className="supply-details-text">
          <div className="supply-details-row">
            <span className="supply-details-label"><strong>Lead ID:</strong></span>
            <span className="supply-details-value">{mprData.leadID}</span>
          </div>
          <div className="supply-details-row">
            <span className="supply-details-label"><strong>MPR Number:</strong></span>
            <span className="supply-details-value">{mprData.mpr_number}</span>
          </div>
          <div className="supply-details-row">
            <span className="supply-details-label"><strong>Lead Status:</strong></span>
            <span className="supply-details-value">{mprData.lead_status_name}</span>
          </div>
          <div className="supply-details-row">
            <span className="supply-details-label"><strong>Sales Status:</strong></span>
            <span className="supply-details-value">{mprData.sales_status_name}</span>
          </div>
        </Text>
      </Form.Item>
         
        )}
      </Form>

     
    </div>

    <div style={{ padding: '5px' }}>
      {/* Form with label and input for MPR field */}
      <Form layout="inline">
        <Form.Item label="Supply Number" style={{marginLeft:'20px',fontSize:'6px',marginTop:'8px'}}>
          <Input
          style={{fontSize:'13px'}}
            value={supplyNumber}
            onChange={(e) => setSupplyNumber(e.target.value)}
            placeholder="Enter Supply Number"
          />
        </Form.Item>
        <Button type="primary" onClick={handleSupplyNumberCheck}  style={{marginRight:'15px',marginTop:'8px'}}>
        Check
      </Button>
     
      {/* Display the response data */}
      {supplyNumberData && (
          <Form.Item className="supply-details-form-item">
          <Text className="supply-details-text">
            <div className="supply-details-row">
              <span className="supply-details-label"><strong>Lead ID:</strong></span>
              <span className="supply-details-value">{supplyNumberData.leadID}</span>
            </div>
            <div className="supply-details-row">
              <span className="supply-details-label"><strong>Supply Number:</strong></span>
              <span className="supply-details-value">{supplyNumberData.supply_number}</span>
            </div>
            <div className="supply-details-row">
              <span className="supply-details-label"><strong>Lead Status:</strong></span>
              <span className="supply-details-value">{supplyNumberData.lead_status_name}</span>
            </div>
            <div className="supply-details-row">
              <span className="supply-details-label"><strong>Sales Status:</strong></span>
              <span className="supply-details-value">{supplyNumberData.sales_status_name}</span>
            </div>
          </Text>
        </Form.Item>
        )}
      </Form>

     
    </div>
    <div className='record-show' style={{marginBottom:'10px',fontWeight: 'bold'}}>
  {"Total Records "+totalNoOfRecords}
</div>
    
      <div className='callbacktable'>
        <header className='callbacktable-header'>
          <Table
            columns={columns}
            dataSource={filteredDataSource} // Use filteredDataSource here
            pagination={{ pageSize: 100 }}
            scroll={{ y: 500 }}
            onRow={(record, rowIndex) => ({
              handleClick: event => {
                 handleClick(record);
              },
            })}
          />
        </header>
      </div>
    </div>
  );
};

export default LeadSearchSales;
